var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-result text-center mt-2"},[_c('span',[_vm._v("Không tìm thấy kết quả")])])}]

export { render, staticRenderFns }